import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PlaceNearComponent } from './PlaceNear.component';

@NgModule({
    imports: [CommonModule],
    declarations: [PlaceNearComponent],
    exports: [PlaceNearComponent],
    providers: []
})
export class PlaceNearModule {}
